<template>
  <v-container>
    <div class=" mx-lg-16 mx-md-16">

      <p class="text-right text-h5 fontDarkGrey--text font-weight-medium">
        נדידה בחו"ל
      </p>
      <v-btn plain text x-large class="text-right pr-0 text-h6">
        <span class="text-decoration-underline">
          חבילה יומית - יום ראשון ללא תשלום - 18 ש"ח ליום
        </span>
        <span class="pr-16 error--text"> ביטול </span>
      </v-btn>
      <br />
      <v-btn plain text x-large class="text-right pr-0 text-h6">
        <span class="font-weight-normal text-decoration-underline">
          הוסף חבילה
        </span>
      </v-btn>
      <!-- add roaming pack -->
      <v-row align="start">
        <v-col cols="12" md="2">
          <p class="fontGrey--text text-h6 font-weight-medium mb-0 pr-0">
            מדינות יעד:
          </p>
        </v-col>
        <v-col cols="12" md="3">
          <CountrySelect
          v-model="roamingSubscriptionDetails.country"
          :newSelection="true"
          @selectCountry="handleSelection"
          />
        </v-col>
      </v-row>
      <!--start date -->
      <v-row align="start">
        <v-col cols="12" md="4">
          <v-row align="center">
            <p class="fontGrey--text text-h6 font-weight-medium pr-2 mb-1">
              תאריך התחלה:
            </p>
            <PlainButton
            :buttonText="
              roamingSubscriptionDetails.startDate
              ? formatedDate(roamingSubscriptionDetails.startDate)
              : 'בחר'
              "
            :method="'openDatePicker'"
            @openDatePicker="displayDatePicker = !displayDatePicker"
            :textConfigs="{
              label: 'fontGrey--text text-h5 pr-4 font-weight-medium pr-0',
            }"
          />
        </v-row>
      </v-col>
      <v-col cols="12" md="1">
        <DateSelect
        v-model="roamingSubscriptionDetails.startDate"
        :openDialog="displayDatePicker"
        @closeDialog="displayDatePicker = !displayDatePicker"
        ></DateSelect>
      </v-col>
      <v-col cols="12" md="2">
        <p class="fontGrey--text text-h6 font-weight-medium pr-0 mb-0">
          בחר לתקופה:
        </p>
      </v-col>
      <v-col cols="12" md="2">
        <v-select
        :items="roamingPeriodOptions"
        :label="'בחר'"
        class="pt-0 mt-0"
        ></v-select>
      </v-col>
    </v-row>
    <!-- suggested pack -->
    <p class="text-right text-h5 fontDarkGrey--text font-weight-medium mb-3">
      חבילה מומלצת:
    </p>
    <p class="text-right text-h5 fontGrey--text font-weight-medium">
      10 ג"ב דאטה ל30 יום -
      <span class="text-right text-h5 success--text font-weight-medium">
        רק 180 ש"ח
      </span>
    </p>
    <PlainButton
    :textConfigs="{
      label: 'text-h5 mb-0 px-0 fontGrey--text font-weight-bold',
    }"
      :buttonText="'הוסף חבילה'"
      :method="'addPack'"
      @addPack="$emit('saveRoamingPack', 1)"
      />
      <!-- to app download -- TODO link to app -->
      <p class="text-right text-h5 fontDarkGrey--text font-weight-medium mt-10">
        להוריד אפליקציית
        <span class="secondary--text font-weight-bold"> prime line </span>
        ולהנות משיחות בחו"ל בעלות מקומית
      </p>
    </div>
    </v-container>
</template>

<script>
import join from "lodash/join";
import trimStart from "lodash/trimStart";
import words from "lodash/words";
import apiCalls from "@/mixins/apiCalls.js";

export default {
  name: "NewRoamingPack",
    mixins: [apiCalls],
  components: {
    CountrySelect: () =>
      import("@/components/CommonComponents/Selects/CountrySelect"),
    DateSelect: () =>
      import("@/components/CommonComponents/Dialogs/DateSelect"),
    PlainButton: () =>
      import("@/components/CommonComponents/Buttons/PlainButton"),
  },
  props: {},
  data() {
    return {
      roamingSubscriptionDetails: {
        countryCode: null,
        country: null,
        startDate: null,
      },
      roamingPeriodOptions: ["שבוע", "חודש", "רבעון", "חצי שנה", "שנה"],
      selectedPeriod: null,
      displayDatePicker: false,
    };
  },
  methods: {      
    formatedDate(dateStr) {
      let date = words(dateStr);
      let day = date.pop();
      let month = date.pop();
      let year = date.pop();
      let formatedDate = join([day, month, year], "/");
      return formatedDate;
    },
    handleSelection(country) {
      this.roamingSubscriptionDetails.countryCode = trimStart(country.dial_code, "+");
      this.roamingSubscriptionDetails.country = country;
    },
  },
};
</script>
